import React from 'react';

import type { ProductLogoSvgProps } from '../types';

export const InRobot: React.FC<
  React.PropsWithChildren<ProductLogoSvgProps>
> = ({ size = '40' }) => (
  <svg
    height={size}
    width={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cogs-v11 cogs-graphic cogs-graphic--bestday"
  >
    <title>InRobot product logo</title>
    <path
      d="M24.1987 1.47145C24.7097 1.33453 25.2549 1.48062 25.629 1.85467L38.1462 14.3716C38.5203 14.7456 38.6664 15.2908 38.5295 15.8018L33.9478 32.9002C33.8109 33.4111 33.4118 33.8102 32.9008 33.9472L15.8019 38.5287C15.291 38.6656 14.7458 38.5195 14.3717 38.1454L1.85444 25.6285C1.48038 25.2545 1.33429 24.7093 1.4712 24.1983L6.05284 7.09993C6.18975 6.58897 6.58887 6.18986 7.09985 6.05295L24.1987 1.47145Z"
      fill="url(#paint0_linear_2853_36563)"
    />
    <path
      d="M24.1987 1.47145C24.7097 1.33453 25.2549 1.48062 25.629 1.85467L38.1462 14.3716C38.5203 14.7456 38.6664 15.2908 38.5295 15.8018L33.9478 32.9002C33.8109 33.4111 33.4118 33.8102 32.9008 33.9472L15.8019 38.5287C15.291 38.6656 14.7458 38.5195 14.3717 38.1454L1.85444 25.6285C1.48038 25.2545 1.33429 24.7093 1.4712 24.1983L6.05284 7.09993C6.18975 6.58897 6.58887 6.18986 7.09985 6.05295L24.1987 1.47145Z"
      fill="url(#paint1_linear_2853_36563)"
    />
    <g opacity="0.95">
      <path
        d="M22.6899 8.08042C22.9454 8.01196 23.218 8.085 23.405 8.27203L31.5853 16.4521C31.7723 16.6391 31.8454 16.9117 31.7769 17.1672L28.7827 28.3414C28.7143 28.5969 28.5147 28.7964 28.2592 28.8649L17.0847 31.859C16.8292 31.9274 16.5566 31.8544 16.3696 31.6674L8.18927 23.4873C8.00224 23.3003 7.9292 23.0277 7.99766 22.7722L10.9919 11.598C11.0603 11.3425 11.2599 11.143 11.5154 11.0745L22.6899 8.08042Z"
        fill="#FFBE82"
      />
      <path
        d="M22.6899 8.08042C22.9454 8.01196 23.218 8.085 23.405 8.27203L31.5853 16.4521C31.7723 16.6391 31.8454 16.9117 31.7769 17.1672L28.7827 28.3414C28.7143 28.5969 28.5147 28.7964 28.2592 28.8649L17.0847 31.859C16.8292 31.9274 16.5566 31.8544 16.3696 31.6674L8.18927 23.4873C8.00224 23.3003 7.9292 23.0277 7.99766 22.7722L10.9919 11.598C11.0603 11.3425 11.2599 11.143 11.5154 11.0745L22.6899 8.08042Z"
        fill="url(#paint2_radial_2853_36563)"
      />
    </g>
    <path
      d="M33.7267 33.726L20.0004 20.0001L1.25 25.0241L14.9763 38.75L33.7267 33.726Z"
      fill="url(#paint3_linear_2853_36563)"
      fillOpacity="0.55"
    />
    <path
      d="M25.0237 1.25L19.9996 19.9999L33.7258 33.7257L38.75 14.9759L25.0237 1.25Z"
      fill="url(#paint4_linear_2853_36563)"
      fillOpacity="0.25"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2853_36563"
        x1="30.1388"
        y1="-17.1082"
        x2="-15.0444"
        y2="4.34132"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFBB00" />
        <stop offset="1" stopColor="#FF6917" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2853_36563"
        x1="46.1922"
        y1="3.70478"
        x2="-6.37268"
        y2="15.3656"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.6" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_2853_36563"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.9597 19.0301) rotate(-172.001) scale(19.5577 22.4249)"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint3_linear_2853_36563"
        x1="20.3044"
        y1="19.729"
        x2="8.28453"
        y2="36.9572"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2853_36563"
        x1="20.2161"
        y1="20.0579"
        x2="39.0111"
        y2="9.11902"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
